// 以下に app/frontend/js 配下のスクリプトをimportする
import { Application } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

Turbo.session.drive = false

import '@fortawesome/fontawesome-free/css/all.css';

// modal-video
import 'modal-video/css/modal-video.css';

// tom-select
import 'tom-select/dist/css/tom-select.bootstrap4.css';

//scss import
import '@/stylesheets/customer.scss';

// js import
import './modal-video-youtube.js';

// Stimulus controllers import
import { AccordionController } from './accordion-controller.js';
import { AccountTypeSwitcherController } from './account-type-switcher-controller.js';
import { AgreementModalController } from './agreement-modal-controller.js';
import { AnnounceCarouselController } from './announce-carousel-controller.js';
import { ApplicationCancelModalController } from './application-cancel-modal-controller.js';
import { ApplicationPurchaseController } from './application-purchase-controller.js';
import { HarvestChartController } from './harvest-chart-controller.js';
import { ModalController } from './modal-controller.js';
import { NoEnterSubmitController } from "./no_enter_submit_controller";
import { PopupController } from './popup-controller.js';
import { SameAsRepresentativeController } from "./same-as-representative-controller";
import { SimpleModalController } from "./simple-modal-controller";
import { TabController } from './tab-controller.js';
import { ScrollToFrameController } from './scroll-to-frame-controller.js';
import { ZipcodeAutofillController } from "./zipcode-autofill-controller";
import { TogglePasswordController } from "./toggle-password-controller";
import { AccountFormValidationController } from "./account-form-validation-controller";
import { DismissibleAlertController } from "./dismissible-alert-controller.js";
import { FocusNoScrollController } from "./focus-no-scroll-controller.js";
import { MetricSwitcherController } from './metric-switcher-controller.js';
import { IdentityVerificationStatusController } from './identity-verification-status-controller.js';
import TomSelectController from "./tom-select-controller";

// Start Stimulus application once
const application = Application.start();

// Register all controllers
application.register("accordion", AccordionController);
application.register("account-type-switcher", AccountTypeSwitcherController);
application.register("agreement-modal", AgreementModalController);
application.register("announce-carousel", AnnounceCarouselController);
application.register("application-cancell-modal", ApplicationCancelModalController);
application.register("application-purchase", ApplicationPurchaseController);
application.register("harvest-chart", HarvestChartController);
application.register("modal", ModalController);
application.register("tab", TabController);
application.register("scroll-to-frame", ScrollToFrameController);
application.register("popup", PopupController);
application.register("zipcode-autofill", ZipcodeAutofillController);
application.register("no-enter-submit", NoEnterSubmitController);
application.register("same-as-representative", SameAsRepresentativeController);
application.register("simple-modal", SimpleModalController);
application.register("toggle-password", TogglePasswordController);
application.register("account-form-validation", AccountFormValidationController);
application.register("dismissible-alert", DismissibleAlertController);
application.register("focus-no-scroll", FocusNoScrollController);
application.register("metric-switcher", MetricSwitcherController);
application.register("identity-verification-status", IdentityVerificationStatusController);
application.register("tom-select", TomSelectController);

